import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Loader from "@/components/Loader";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "sonner";

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loading) document.documentElement.classList.add("loading");
    else document.documentElement.classList.remove("loading");
  }, [loading]);

  return (
    <>
      {loading && <Loader onDone={() => setLoading(false)} />}
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home loading={loading} key={loading ? "l" : "h"} />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0e0e0e",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </>
  );
}
